import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import CommunityProfile from './pages/CommunityProfile';
import Categories from './pages/Categories';
import UserProfile from './pages/UserProfile';
import Onboarding from './pages/Onboarding';
import Events from './pages/Events';
import MyTickets from './pages/MyTickets';
import Search from './pages/Search';
import Forum from './pages/Forum';
import Jobs from './pages/Jobs';
import CategoryDetail from './pages/CategoryDetail';
import Footer from './components/Footer';
import Movies from './pages/Movies';
import Tickets from './pages/Tickets';
import SellerLogin from './pages/SellerLogin';
import DealsDiscounts from './pages/DealsDiscounts';
import DailyVibeCheck from './pages/DailyVibeCheck';
import Register from './pages/Register';
import SellerInfo from './pages/SellerInfo';
import Help from './pages/Help';
import Partner from './pages/Partner';
import Blog from './pages/Blog';
import Checkout from './pages/Checkout';
import TicketingServices from './pages/TicketingServices';
import Contact from './pages/Contact';
import HelpFAQs from './pages/HelpFAQs';
export function App() {
  return <div className="flex flex-col min-h-screen bg-white dark:bg-gray-900" data-id="element-0">
      <Navigation data-id="element-1" />
      <div className="flex-1 overflow-auto pt-16" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/community/:id" element={<CommunityProfile data-id="element-7" />} data-id="element-6" />
          <Route path="/communities" element={<Categories data-id="element-9" />} data-id="element-8" />
          <Route path="/categories/:id" element={<CategoryDetail data-id="element-11" />} data-id="element-10" />
          <Route path="/profile" element={<UserProfile data-id="element-13" />} data-id="element-12" />
          <Route path="/onboarding" element={<Onboarding data-id="element-15" />} data-id="element-14" />
          <Route path="/events" element={<Events data-id="element-17" />} data-id="element-16" />
          <Route path="/tickets" element={<Tickets data-id="element-19" />} data-id="element-18" />
          <Route path="/search" element={<Search data-id="element-21" />} data-id="element-20" />
          <Route path="/forum" element={<Forum data-id="element-23" />} data-id="element-22" />
          <Route path="/jobs" element={<Jobs data-id="element-25" />} data-id="element-24" />
          <Route path="/movies" element={<Movies data-id="element-27" />} data-id="element-26" />
          <Route path="/seller-login" element={<SellerLogin data-id="element-29" />} data-id="element-28" />
          <Route path="/deals-discounts" element={<DealsDiscounts data-id="element-31" />} data-id="element-30" />
          <Route path="/daily-vibe-check" element={<DailyVibeCheck data-id="element-33" />} data-id="element-32" />
          <Route path="/register" element={<Register data-id="element-35" />} data-id="element-34" />
          <Route path="/seller-info" element={<SellerInfo data-id="element-37" />} data-id="element-36" />
          <Route path="/help&FAQs" element={<HelpFAQs data-id="element-39" />} data-id="element-38" />
          <Route path="/partner" element={<Partner data-id="element-41" />} data-id="element-40" />
          <Route path="/blog" element={<Blog data-id="element-43" />} data-id="element-42" />
          <Route path="/checkout" element={<Checkout data-id="element-45" />} data-id="element-44" />
          <Route path="/ticketing-services" element={<TicketingServices data-id="element-47" />} data-id="element-46" />
          <Route path="/contact" element={<Contact data-id="element-49" />} data-id="element-48" />
        </Routes>
      </div>
      <Footer data-id="element-50" />
    </div>;
}